import { entries } from './object';
function idfSmooth(term, frequencies, totalDocuments) {
    const nt = 1 + frequencies.filter((frequency) => frequency[term] > 0).length;
    return 1 + Math.log(totalDocuments / nt);
}
export function countIdf(termFrequencies, documentTermFrequencies, totalDocuments) {
    return entries(termFrequencies).reduce((tfidf, [term, tf]) => {
        const idf = idfSmooth(term, documentTermFrequencies, totalDocuments);
        return tfidf + tf * idf;
    }, 0);
}
//# sourceMappingURL=tf-idf.js.map